export default "__VITE_ASSET__DVD4ahPQ__"